import React, { Fragment } from 'react';
import { ButtonGroup } from 'react-bootstrap';
import { FaEdit, FaSave } from 'react-icons/fa';
import { MdCancel, MdDelete } from 'react-icons/md';
import { ArcaHttpClientInvoice } from '../../../code/ArcaHttpClientInvoice';
import { ArcaHttpSystem } from '../../../code/ArcaHttpSystem';
import { ArcaSecurity } from '../../../code/ArcaSecurity';
import { ArcaComponent } from '../../pages/ArcaComponent';
import { ArcaLink } from '../Fields/ArcaLink';
import { StatusBar } from '../StatusBar';
import { InvoiceEntryEditPanel } from './InvoiceEntryEditPanel';

export class InvoiceEditPanel extends ArcaComponent {

    constructor(props) {
        super(props);
        this.state = {
            invoice: this.props.invoice,
            mark: Math.random(),
            invoiceEntry: null,
            editedEntryId: 0,
            isError: false,
            statusMessage: null
        };
    }

    saveInvoice() {
        ArcaHttpClientInvoice.UpdateExistingInvoice(
            this.state.invoice,
            (msg => {
                this.setState({ isError: false, statusMessage: `Invoice updated:  '${msg}'` });
            }),
            (msg => {
                this.setState({ isError: true, statusMessage: `Error updating the invoice:  '${msg}'` });
            }));
    }

    onEditClick(entry) {
        entry.isEditing = true
        this.setState({ invoiceEntry: entry, editedEntryId: entry.Id })
    }

    onDeleteClick(entry) {
        entry.Deleted = !entry.Deleted;
        this.setState({ invoice: this.state.invoice, mark: Math.random() })
    }

    setRowColour(entry) {
        if (entry.Deleted) return 'rowRed'
        if (entry.Added) return 'rowOrange'
        if (entry.Id === this.state.editedEntryId) return 'rowYellow'
        if (entry.Changed) return 'rowGreen'

        return 'rowNormal'
    }

    onSaveEntryEdit(entry) {
        this.setState({ editedEntryId: 0 })
    }

    onCancelEntryEdit(entry) {
        this.setState({ editedEntryId: 0 })
    }

    render() {
        let { invoice, invoiceEntry, editedEntryId, isError, statusMessage } = this.state
        let topButtons =
            <div className='centerText'>
                <ButtonGroup className='buttonGroup'>
                    {ArcaSecurity.IsAdmin && (invoiceEntry?.Changed || invoiceEntry?.Deleted)
                        ? <ArcaLink text='Save' icon={<FaSave />}
                            onClick={() => this.saveInvoice()} />
                        : null}
                    {ArcaSecurity.IsAdmin
                        ? <ArcaLink text='Cancel' icon={<MdCancel />}
                            onClick={() => this.props.onCancel()} />
                        : null}
                </ButtonGroup>
            </div>
        let instruction = invoice.Status === 'Invoiced'
            ? 'As the invoiced has been sent to the customer, the actual invoice will be voided and the a replacement created.'
            : 'This invoice has not been sent to the customer, so can be edited as is.'


        return (
            <Fragment>
                <p>Invoice Editor</p>
                <b>{instruction}</b>
                {topButtons}
                <StatusBar isError={isError} message={statusMessage} />
                <table className='table' aria-labelledby="tabelLabel">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Description</th>
                            {ArcaHttpSystem.VatEnabled
                                ? <th>Value</th>
                                : null}
                            {ArcaHttpSystem.VatEnabled
                                ? <th> Vat</th>
                                : null}
                            <th>Total</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>

                        {invoice.Entries?.map((e, k) =>
                            <Fragment key={k}>
                                {e.Id === editedEntryId
                                    ? <tr className={this.setRowColour(e)}>
                                        <td>{k + 1}</td>
                                        <td colSpan='3'>
                                            <InvoiceEntryEditPanel
                                                invoiceEntry={invoiceEntry}
                                                onSave={() => this.onSaveEntryEdit(e)}
                                                onCancel={() => this.onCancelEntryEdit(e)}
                                            />
                                        </td>
                                    </tr>
                                    : <Fragment>
                                        <tr className={this.setRowColour(e)}>
                                            <td>{k + 1}</td>

                                            <td>{e.Description}<br /> <small>{e.Reason}</small> </td>
                                            {ArcaHttpSystem.VatEnabled
                                                ? <td>{invoice.CurrencySymbol + e.Value.toFixed(2)}</td>
                                                : null}
                                            {ArcaHttpSystem.VatEnabled
                                                ? <td> {invoice.CurrencySymbol + e.Vat.toFixed(2)}</td>
                                                : null}
                                            <td>{invoice.CurrencySymbol + (e.Value + e.Vat).toFixed(2)}</td>
                                            <td>
                                                {e.Deleted
                                                    ? null
                                                    : <FaEdit
                                                        style={{ color: 'darkblue', cursor: 'pointer' }}
                                                        size={'28'}
                                                        onClick={() => this.onEditClick(e)}
                                                    />
                                                }
                                                {'  '}
                                                {e.Changed
                                                    ? null
                                                    : <MdDelete
                                                        style={{ color: 'darkred', cursor: 'pointer' }}
                                                        size={'28'}
                                                        onClick={() => this.onDeleteClick(e)} />}
                                            </td>
                                        </tr>
                                    </Fragment>}

                            </Fragment>
                        )}

                    </tbody>
                </table>

            </Fragment >
        );
    }
}